"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordHelper = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = __importDefault(require("classnames"));
var password_input_1 = require("../password-input");
var icons_1 = require("@ant-design/icons");
var PasswordHelper = /** @class */ (function (_super) {
    __extends(PasswordHelper, _super);
    function PasswordHelper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            focused: false,
            allCriteriaMet: false,
            comlexityCriteriaMet: false,
            validation: {}
        };
        _this.handleFocus = function (event) {
            event && event.persist();
            var onFocus = _this.props.onFocus;
            _this.setState({ focused: true });
            if (typeof onFocus === 'function') {
                onFocus(event);
            }
        };
        _this.handleBlur = function (event) {
            event && event.persist();
            var onBlur = _this.props.onBlur;
            _this.setState({ focused: false });
            if (typeof onBlur === 'function') {
                onBlur(event);
            }
        };
        return _this;
    }
    PasswordHelper.getDerivedStateFromProps = function (props, state) {
        var _a = props.value, value = _a === void 0 ? '' : _a, meetsAllCriteria = props.meetsAllCriteria, passwordRules = props.passwordRules, complexityRequirement = props.passwordRules.complexityRequirement;
        var prevCriteriaMet = state.allCriteriaMet, prevPasswordLength = state.currentPwdLength;
        var complexity = (passwordRules === null || passwordRules === void 0 ? void 0 : passwordRules.complexity) || [];
        var currentPwdLength = value.length;
        if (prevCriteriaMet && prevPasswordLength === currentPwdLength) {
            return null;
        }
        var complexityTests = {
            isLowerCaseRequired: /^(?=.*[a-z]).+$/,
            isUpperCaseRequired: /^(?=.*[A-Z]).+$/,
            isSpecialCharRequired: /[-!$%#@^&*()_+|~=`{}[\]:";'<>?,./]/,
            isNumberRequired: /[0-9]/
        };
        var validation = {
            lengthValid: currentPwdLength >= (passwordRules === null || passwordRules === void 0 ? void 0 : passwordRules.minLength),
            complexityValidation: {}
        };
        var complexityResults = [];
        var complexityCount = 0;
        var complexityCriteriaMet = false;
        var allCriteriaMet = false;
        complexity.forEach(function (rule) {
            validation.complexityValidation[rule] = complexityTests[rule].test(value);
        });
        complexityResults = Object.values(validation.complexityValidation);
        complexityCount = complexityResults.reduce(function (count, valid) {
            return valid ? ++count : count;
        }, 0);
        complexityCriteriaMet = complexityCount >= complexityRequirement;
        allCriteriaMet = validation.lengthValid && complexityCriteriaMet;
        if (typeof meetsAllCriteria === 'function') {
            if (allCriteriaMet || (prevCriteriaMet && !allCriteriaMet)) {
                meetsAllCriteria(allCriteriaMet);
            }
        }
        return {
            validation: validation,
            complexityCriteriaMet: complexityCriteriaMet,
            allCriteriaMet: allCriteriaMet,
            currentPwdLength: currentPwdLength
        };
    };
    PasswordHelper.prototype.render = function () {
        var _a = this.props, className = _a.className, _b = _a.passwordRules, passwordRules = _b === void 0 ? {} : _b, _c = _a.passwordRulesLabels, passwordRulesLabels = _c === void 0 ? {} : _c, _d = _a.value, value = _d === void 0 ? '' : _d, name = _a.name, label = _a.label, helpComponent = _a.helpComponent, meetsAllCriteria = _a.meetsAllCriteria, props = __rest(_a, ["className", "passwordRules", "passwordRulesLabels", "value", "name", "label", "helpComponent", "meetsAllCriteria"]);
        var complexityRules = (passwordRules === null || passwordRules === void 0 ? void 0 : passwordRules.complexity) || [];
        var complexityLabels = (passwordRulesLabels === null || passwordRulesLabels === void 0 ? void 0 : passwordRulesLabels.complexity) || {};
        var _e = this.state, focused = _e.focused, allCriteriaMet = _e.allCriteriaMet, complexityCriteriaMet = _e.complexityCriteriaMet, _f = _e.validation, complexityValidation = _f.complexityValidation, lengthValid = _f.lengthValid;
        var classes = (0, classnames_1.default)('nkl-password-helper', 'nkl-text-input', { 'is-focused': focused }, className);
        var minLengthClass = lengthValid
            ? 'nkl-password-helper--passes'
            : 'nkl-password-helper--fails';
        var complexityClass = complexityCriteriaMet
            ? 'nkl-password-helper--passes'
            : 'nkl-password-helper--fails';
        return (react_1.default.createElement("div", { className: classes },
            // password rules in a container element
            helpComponent
                && react_1.default.createElement("span", { className: 'nkl-input-helper' }, helpComponent),
            label
                && react_1.default.createElement("label", { htmlFor: name }, label),
            react_1.default.createElement("div", { className: 'nkl-password-helper-inner' },
                react_1.default.createElement(password_input_1.PasswordInput, __assign({ onInputFocus: this.handleFocus, onInputBlur: this.handleBlur, onCheckboxFocus: this.handleFocus, onCheckboxBlur: this.handleBlur, name: name, value: value }, props)),
                react_1.default.createElement("div", { className: 'nkl-password-helper-rules', "aria-label": "password requirements" },
                    react_1.default.createElement("ul", null,
                        react_1.default.createElement("li", { className: minLengthClass },
                            react_1.default.createElement(icons_1.CheckCircleOutlined, { className: 'nkl-icon' }),
                            ' ', passwordRulesLabels === null || passwordRulesLabels === void 0 ? void 0 :
                            passwordRulesLabels.minLength),
                        react_1.default.createElement("li", { className: complexityClass },
                            react_1.default.createElement(icons_1.CheckCircleOutlined, { className: 'nkl-icon' }),
                            ' ', passwordRulesLabels === null || passwordRulesLabels === void 0 ? void 0 :
                            passwordRulesLabels.complexityRequirement,
                            react_1.default.createElement("ul", null, complexityRules.map(function (rule) {
                                var classes = complexityValidation[rule]
                                    ? 'nkl-password-helper--passes'
                                    : 'nkl-password-helper--fails';
                                return react_1.default.createElement("li", { key: rule, className: classes },
                                    react_1.default.createElement(icons_1.CheckCircleOutlined, { className: 'nkl-icon' }),
                                    ' ',
                                    complexityLabels[rule]);
                            }))))))));
    };
    return PasswordHelper;
}(react_1.default.Component));
exports.PasswordHelper = PasswordHelper;
PasswordHelper.propTypes = {
    onFocus: prop_types_1.default.func,
    onBlur: prop_types_1.default.func,
    className: prop_types_1.default.string,
    passwordRules: prop_types_1.default.object,
    passwordRulesLabels: prop_types_1.default.object,
    value: prop_types_1.default.string,
    name: prop_types_1.default.string,
    label: prop_types_1.default.node,
    helpComponent: prop_types_1.default.node
};
//# sourceMappingURL=password-helper.js.map